/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import axios from 'axios'; 
import toast from '../../services/toast';
export default {
  name: 'user-connection-request-list',
  components: {},
  props: [],
  data () {
    return {
      connReqList:{},
      userLoading: false,
      submitted:false,
    }
  },
  computed: {
  ...mapGetters([
    'userChatRequestListGetters'
  ]),
  getconnReqListDetailsFun(){
    return this.connReqList = this.$store.getters.userChatRequestListGetters.data
  },
  },
  mounted () {
    this.getconnReqListDetailsFun
  },
  methods: {
  },
  watch:{
    getconnReqListDetailsFun(){
      return this.connReqList = this.$store.getters.userChatRequestListGetters.data
    },
  },
  beforeRouteLeave: function(to, from, next) {
    next();
  },
}